import React from 'react';
import Button from '../ui/Button';
import { useForm } from 'react-hook-form';
import FormInput from '../ui/FormInput';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import AuthFormShell from '../layout/AuthFormShell';
import AuthBackLink from './AuthBackLink';

const schema = yup.object().shape({
  password: yup.string().required('Password is required'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwords must match')
    .required('Confirm password is required')
});

const CreatePasswordForm = ({ onSubmit, isLoading, isChallengeFlow = false }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  return (
    <AuthFormShell
      title={isChallengeFlow ? 'Set a new password' : 'Set your password'}
      subtitle={
        isChallengeFlow
          ? 'Your account requires a new password before you can continue.'
          : 'Choose a strong password to secure your HousinGram account.'
      }>
      <form className="flex flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-4">
          <div className="w-full">
            <FormInput
              width={100}
              register={register}
              register_key="password"
              label="Password"
              type="password"
              isRequired
              autoComplete="new-password"
              errors={errors}
            />
            {errors.password && (
              <p className="mt-1 text-sm text-red-500">{errors.password.message}</p>
            )}
          </div>

          <div className="w-full">
            <FormInput
              width={100}
              register={register}
              register_key="confirmPassword"
              label="Confirm Password"
              type="password"
              isRequired
              autoComplete="new-password"
              errors={errors}
            />
            {errors.confirmPassword && (
              <p className="mt-1 text-sm text-red-500">{errors.confirmPassword.message}</p>
            )}
          </div>

          <p className="text-xs text-gray-500">
            Password must be at least 8 characters and include uppercase, lowercase, a number, and
            a special character.
          </p>
        </div>

        <Button type="submit" displayType="full-w-primary" width={100} isLoading={isLoading}>
          {isChallengeFlow ? 'Set Password' : 'Create Password'}
        </Button>

        <AuthBackLink />
      </form>
    </AuthFormShell>
  );
};

export default CreatePasswordForm;
